import React from 'react';

import { Icon } from '../../../../components';
import { Pill, DELTA_COLORS, type DeltaVariant } from './Delta.styles';

/** Canonical pill font size (px). Every delta pill on Home renders at this size so
 *  the +/-X% pills are visually identical across sections — do not override it per
 *  call site without a deliberate design reason. */
export const DELTA_SIZE = 13;

export type DeltaProps = {
  /** Signed percentage; negative flips the pill to the down (red) variant. */
  value: number;
  /** Positive tone — `emerald` (default) or the brighter `success` fill. */
  tone?: 'emerald' | 'success';
  /** Font size (px). Defaults to {@link DELTA_SIZE}; leave unset for the shared look. */
  size?: number;
};

/** "+12% ↑" delta pill. The percentage is a numeric value (plain node); the
 *  trend arrow and tint resolve from the variant. */
export const Delta = ({ value, tone = 'emerald', size = DELTA_SIZE }: DeltaProps): React.ReactElement => {
  const down = value < 0;
  const variant: DeltaVariant = down ? 'down' : tone;
  return (
    <Pill $variant={variant} style={{ fontSize: size }}>
      <Icon name={down ? 'trending-down' : 'trending-up'} size={size <= 11 ? 10 : 12} color={DELTA_COLORS[variant].fg} />
      {`${down ? '' : '+'}${value}%`}
    </Pill>
  );
};

export default Delta;
